 
<ng-content>

</ng-content>
<h1  >
    <div #blinker class="blinker blinker-lg"></div>
</h1>